import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import EmployerDashboard from "@/pages/EmployerDashboard";
import EmployerAdminGate from "@/components/EmployerAdminGate";

export const Route = createFileRoute("/employer-dashboard")({
  head: () => seoHead("/employer-dashboard"),
  component: () => (
    <EmployerAdminGate><EmployerDashboard /></EmployerAdminGate>
  ),
});
